export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
    },
    filter: {
      causer_id: null,
      subject_type: null,
      date_from: null,
      date_to: null,
    },
    admins: [],
    subjectTypes: [],
  },

  mutations: {
    setDataList(state, data) {
      data.forEach((item) => {
        const exists = state.list.find((i) => i.id === item.id)
        if (!exists) {
          state.list.push(item)
        }
      })
    },

    clearList(state) {
      state.list = []
      state.listMeta = { current_page: 0, last_page: 1 }
    },

    setDataListMeta(state, meta) {
      state.listMeta = meta
    },

    setFilter(state, filter) {
      state.filter = filter
    },

    resetFilter(state) {
      state.filter = {
        causer_id: null,
        subject_type: null,
        date_from: null,
        date_to: null,
      }
    },

    setAdmins(state, data) {
      state.admins = data
    },

    setSubjectTypes(state, data) {
      state.subjectTypes = data
    },
  },

  actions: {
    async getDataList({ commit, state }, params = {}) {
      const { page = 1 } = params
      const queryParams = new URLSearchParams()

      queryParams.append('page', page)
      queryParams.append('limit', 50)
      queryParams.append('sort', '-created_at')

      if (state.filter.causer_id) {
        queryParams.append('filter[causer_id]', state.filter.causer_id)
      }
      if (state.filter.subject_type) {
        queryParams.append('filter[subject_type]', state.filter.subject_type)
      }
      if (state.filter.date_from) {
        queryParams.append('filter[date_from]', state.filter.date_from)
      }
      if (state.filter.date_to) {
        queryParams.append('filter[date_to]', state.filter.date_to)
      }

      const { data } = await this.$api.get(
        `activity-logs?${queryParams.toString()}`
      )

      commit('setDataList', data.data)
      commit('setDataListMeta', data.meta)
    },

    async getAdmins({ commit }) {
      const { data } = await this.$api.get('admins')
      commit('setAdmins', data.data)
    },

    async getSubjectTypes({ commit }) {
      const { data } = await this.$api.get('activity-logs/subject-types')
      commit('setSubjectTypes', data.data)
    },
  },
}
